module.exports = __webpack_public_path__ + "img/five-ways-to-improve-child-decision-making.d0e2e95.jpg";